<template>
    <FormSection title="Preadmission Notes" type="his-section" :full-height="false" :application-id="application">
        <template #content>
            <div class="d-flex flex-column px-3 py-2">
                <Pagination ref="notesList" :page-changed="pageChangedCallback" :isLoading="isLoading">
                    <table class="table table-responsive-md border border-gray">
                        <thead>
                            <tr class="bg-table-header">
                                <th>Title</th>
                                <th>Date</th>
                                <th>User</th>
                                <th class="text-end">Actions</th>
                            </tr>
                        </thead>
                        <tbody v-if="isLoading || isError || !hasData">
                            <!-- LOADING -->
                            <tr v-for="i of loadingCount" class="table-loading" :key="i" v-if="isLoading">
                                <td v-for="i of columns" :key="i">
                                    <span class="shimmer-loading"></span>
                                </td>
                            </tr>
                            <!-- EMPTY -->
                            <tr class="table-empty" v-if="!isLoading && !isError && !hasData">
                                <td :colspan="columns">
                                    <h5>No Preadmission Notes Found</h5>
                                </td>
                            </tr>
                            <!-- ERROR -->
                            <tr class="table-error" v-if="!isLoading && isError">
                                <td :colspan="columns">
                                    <ErrorMessageHandler title="Preadmission Notes" :try-again="resetList" />
                                </td>
                            </tr>
                        </tbody>
                        <PreadmissionNotesRow
                            v-else
                            v-for="notes of page.items"
                            :key="notes.id"
                            :note="notes"
                            :patientDetails="patientDetails"
                            :columns="columns"
                            :reset-list="resetList"
                            :application="application"
                            :accountId="accountId"
                            :patientId="patientId"
                        />
                    </table>
                </Pagination>
            </div>
        </template>
    </FormSection>
</template>

<script src="./PreadmissionNotes.ts"></script>
